import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import CheckBox from "../../../../components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import RadioButton from "../../../../components/hookForms/radioButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceCliente from "../../../../services/serviceCliente";
import serviceRelatorio from "../../../../services/serviceRelatorio";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function Refaturamento({ open, onClose }: IDialogProps) {
    const [clienteDataOptions, setClienteDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);
    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            idsClientes: "",
            dataInicio: "",
            dataFim: "",
        },
    });

    useEffect(() => {
        setClienteData();
    }, []);

    const setClienteData = async () => {
        serviceCliente
            .getClientes()
            .then((result) => {
                setClienteDataOptions(result?.data);
            })
            .catch(() => {
                setClienteDataOptions([]);
            });
    };

    const getRelatorio = async (filters) => {
        setDisabled(true);

        serviceRelatorio
            .getRelatorioRefaturamento(filters)
            .then((result) => {
                if (result) {
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                onClose();
                if (filters.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    const onSubmit = (values: any) => {
        let dataInicio = new Date(values.dataInicio);
        let dataFim = new Date(values.dataFim);

        const treatedValues = {
            ...values,
            relatorioTipoID: 16,
            idsClientes: values.idsClientes ? Number(values.idsClientes) : "",
            dataInicio: values.dataInicio ? format(values.dataInicio, "yyyy-MM-01") : "",
            dataFim: values.dataFim ? format(values.dataFim, "yyyy-MM-01") : "",
        };
        getRelatorio(treatedValues);
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Refaturamento</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {disabled && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <S.Subtitles>Período de referência</S.Subtitles>
                        <Grid container spacing={2} display="flex" alignItems="center">
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Início"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="idsClientes"
                                    label="Clientes"
                                    options={clienteDataOptions}
                                    control={control}
                                    error={errors}
                                    concatWithID={true}
                                />
                            </Grid>
                        </Grid>

                        <S.Spacing />
                        <Grid item xs={12} md={6}>
                            <CheckBox
                                name="redirecionar"
                                label="Redirecionar para a tela de relatório"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            type="submit"
                            variant="contained"
                            disabled={disabled}
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
